import React from "react";
import { ReactComponent as HeartIcon } from "../../../../inlineSvgs/heart.svg";
import { ReactComponent as ArrowIcon } from "../../../../inlineSvgs/arrow-right-2.svg";
import { Link } from "react-router-dom";

const SelectService = ({ service }) => {
  console.log()
  return (
    <Link to="/booking/service" className="select-sub-service order-param">
      <HeartIcon />
      {service ? (
        <div className="service-info info">
          <div className="title">{service.title}</div>
          <div className="sub-title">Service</div>
        </div>
      ) : (
        <div className="not-info">
          <div className="title">Select Service</div>
          <div className="sub-title">Let’s use it before it’s burnt</div>
        </div>
      )}
      <ArrowIcon />
    </Link>
  );
};

export default SelectService;
